<script setup>
import { ref, onBeforeMount } from 'vue';
import API from '../../../api/api-main';
import { transaction } from '@/stores/transaction';
import { format } from 'date-fns';
import { getCurrentInstance } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useUserStore } from '@/stores/user';

const permissions = useUserStore();
const { proxy } = getCurrentInstance();
const toast = useToast();
const Transaction = transaction();
const selectedInvoice = ref('');
const isLoading = ref(false);
const dialog = ref(false);
const DataInvoice = ref([]);
const selectedProduct = ref('');
const fnT = Transaction.$state;

onBeforeMount(() => {
    document.addEventListener('keydown', function (event) {
        if (event.key === 'F6') {
            event.preventDefault();
            fnT.data[fnT.active].Customer = '';
            setTimeout(() => {
                document.getElementById('AutoCompleteInvoice').querySelector('input').focus();
                document.getElementById('AutoCompleteInvoice').querySelector('input').select();
            }, 100);
        }
    });
});
const searchProduct = async (e, id) => {
    try {
        const { data } = await API.get(`Item/getbyCounter?itemCode=${e}&itemType=${fnT.data[fnT.active].itemType || ''}`);
        const product = data?.items.find((e) => e.id === id);
        return product;
    } catch (error) {}
};
const fetchAllReceiptPO = async (key) => {
    try {
        const { data } = await API.get(`${fnT.data[fnT.active].nameUrl}/invoiceCode?invoiceCode=${key.toUpperCase()}`);

        if (data.item) {
            // Bỏ qua phiếu đã hủy thanh toán (đã hủy đã thanh toán / hủy cọc / hủy chờ thanh toán) —
            // các phiếu này đã kết thúc, không cho nạp lại ở tab Đặt hàng.
            if (data.item.canceled) return;

            if (!data.item.canceled && data.item.canceledInvoice && data.item.canceledIssue && data.item.isIssue) return;

            if (data.item.canceledIssue && permissions.checkPermissions('Pos_Selling_Create')) return;

            if (data.item.isIssue && !data.item.canceledIssue && data.item.status == 'CP' && permissions.checkPermissions('Pos_Selling_Payment')) return;

            // if (data.item.status == 'CP' && permissions.checkPermissions('Pos_Selling_Payment')) return;

            selectedInvoice.value = data.item;

            if (selectedInvoice.value.paidPercent < 100 && selectedInvoice.value.status == 'DPM') {
                const productPromises = selectedInvoice.value.itemDetail.map(async (e) => {
                    const product = await searchProduct(e.itemCode, e.itemId);
                    product.itemId = e.itemId;
                    product.id = e.id;
                    fnT.data[fnT.active].Products.push({ ...product, quantity: e.quantity });
                });

                await Promise.all(productPromises); // Chờ tất cả các promises hoàn thành
                Transaction.SET_PRODUCT(true);

                // Cập nhật lại itemDetail sau khi xử lý xong
                selectedInvoice.value.itemDetail = fnT.data[fnT.active].payload.itemDetail;
                selectedInvoice.value.total = 0;
                selectedInvoice.value.itemDetail.forEach((item) => {
                    selectedInvoice.value.total += (item.weightGold || 1) * item.price * item.quantity;
                });
            }

            fnT.data[fnT.active].payload = selectedInvoice.value;

            // Ở bước CHƯA thu cọc (status 'O'): giữ paidDpm/paidPercent THỰC TẾ (=0 khi chưa cọc),
            // không suy ra "đã thu đủ". Các trạng thái khác giữ hành vi cũ (fallback = total / 100%)
            // để tương thích với các phiếu cũ không dùng đặt cọc một phần.
            if (fnT.data[fnT.active].payload.status === 'O') {
                fnT.data[fnT.active].payload.paidDpm = fnT.data[fnT.active].payload.paidDpm > 0 ? fnT.data[fnT.active].payload.paidDpm : 0;
                fnT.data[fnT.active].payload.paidPercent = fnT.data[fnT.active].payload.paidPercent > 0 ? fnT.data[fnT.active].payload.paidPercent : 0;
            } else {
                fnT.data[fnT.active].payload.paidDpm = fnT.data[fnT.active].payload.paidDpm > 0 ? fnT.data[fnT.active].payload.paidDpm : fnT.data[fnT.active].payload.total;
                fnT.data[fnT.active].payload.paidPercent = fnT.data[fnT.active].payload.paidPercent > 0 ? fnT.data[fnT.active].payload.paidPercent : 100;
            }

            if (!fnT.data[fnT.active].payload.paymentMethod?.length) {
                fnT.data[fnT.active].payload.paymentMethod = [
                    {
                        id: 0,
                        fatherId: 0,
                        paymentMethodCode: 'Cash',
                        paymentMethodName: 'Tiền mặt',
                        amount: fnT.data[fnT.active].payload.total || 0
                    }
                ];
            } else {
                if (fnT.data[fnT.active].payload.total - fnT.data[fnT.active].payload.paidDpm > 0 && fnT.data[fnT.active].payload.status == 'DPM') {
                    // Bước thu phần còn lại: KHÔNG được xóa/ghi đè các dòng thanh toán cọc gốc do backend
                    // trả về (paymentMethodId, thông tin ngân hàng...) — nếu mất dữ liệu này, backend sẽ
                    // không đối chiếu được với paidDpm đã lưu khi hủy phiếu ("Tổng tiền thanh toán không
                    // khớp"). Chỉ THÊM 1 dòng mới cho phần còn thiếu nếu chưa có dòng nào ngoài cọc
                    // (giống cách SearchOrderJewelry.vue xử lý ở bước 'KHD').
                    const remaining = (fnT.data[fnT.active].payload.total || 0) - (fnT.data[fnT.active].payload.paidDpm || 0) - (fnT.data[fnT.active].payload.distcountAmountVoucher || 0);
                    if (!fnT.data[fnT.active].payload.paymentMethod.some((el) => !el.dpmInvoice)) {
                        fnT.data[fnT.active].payload.paymentMethod.push({
                            id: 0,
                            fatherId: 0,
                            paymentMethodCode: 'Cash',
                            paymentMethodName: 'Tiền mặt',
                            amount: remaining
                        });
                    }
                }
            }
            selectedInvoice.value = '';
        }
    } catch (error) {
        proxy.$notify('E', error?.response?.data?.errors || 'Không tìm thấy hóa đơn', toast);
    } finally {
        dialog.value = false;
    }
};

const clearDetailInvoice = () => {
    selectedInvoice.value = '';
    Transaction.CLEAR_DATA(fnT.active, fnT.data[fnT.active].id);
};

const openDialog = () => {
    getAll();
    dialog.value = true;
};

const getAll = async () => {
    try {
        const { data } = await API.get(`ARInvoice?Page=1&PageSize=5`);
        DataInvoice.value = data.items;
    } catch (error) {}
};
</script>
<template>
    <div>
        <InputGroup class="w-full" v-if="!fnT.data[fnT.active].payload.id">
            <AutoComplete id="AutoCompleteInvoice" class="w-full" placeholder="Tìm kiếm đơn hàng (F6)" v-model="selectedInvoice" optionLabel="invoiceCode" @complete="fetchAllReceiptPO(selectedInvoice)" />
            <InputGroupAddon @click="openDialog()">
                <i class="pi pi-book"></i>
            </InputGroupAddon>
        </InputGroup>
        <ButtonGroup class="flex" v-else>
            <Button class="pi pi-book" severity="secondary"></Button>
            <Button class="w-full" severity="secondary" :label="`Hóa đơn: ${fnT.data[fnT.active].payload.invoiceCode}`"></Button>
            <Button @click="clearDetailInvoice()" severity="secondary" icon="pi pi-times" />
        </ButtonGroup>
    </div>
    <Dialog v-model:visible="dialog" modal header="Danh sách hóa đơn" :style="{ width: '65rem' }">
        <DataTable v-model:selection="selectedProduct" :value="DataInvoice" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" selectionMode="single" tableStyle="min-width: 50rem">
            <template #header>
                <div>
                    <InputText class="w-6" placeholder="Tìm kiếm hóa đơn"></InputText>
                </div>
            </template>
            <Column selectionMode="single" headerStyle="width: 3rem"></Column>
            <Column field="invoiceCode" header="Mã hóa đơn"></Column>
            <Column field="cardCode" header="Mã khách hàng"></Column>
            <Column field="cardName" header="Tên khách hàng"></Column>
            <Column field="total" header="Tổng tiền (VNĐ)" style="text-align: end">
                <template #body="{ data }">
                    <span>{{ Intl.NumberFormat().format(data.total) }}</span>
                </template>
            </Column>
            <Column field="docDate" header="Ngày tạo">
                <template #body="{ data }">
                    {{ format(data.docDate, 'dd/MM/yyyy') }}
                </template>
            </Column>
        </DataTable>
        <template #footer>
            <div class="flex justify-content-end gap-2">
                <Button type="button" label="Bỏ qua" severity="secondary" @click="dialog = false"></Button>
                <Button type="button" label="Xác nhận" @click="fetchAllReceiptPO(selectedProduct.invoiceCode)"></Button>
            </div>
        </template>
    </Dialog>
    <Loading v-if="isLoading"></Loading>
</template>
